import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import SydInput from '../SydInput'
import IconPickerDialog from './IconPickerDialog'

function IconPickerField ({ value, onChange, placeholder }) {
  const [open, setOpen] = useState(false)

  const handleOpen = useCallback(() => setOpen(true), [])
  const handleClose = useCallback(() => setOpen(false), [])

  const handleConfirm = useCallback((iconName) => {
    onChange(iconName)
  }, [onChange])

  return (
    <>
      <div onClick={handleOpen} style={{ cursor: 'pointer' }}>
        <SydInput
          value={value || ''}
          placeholder={placeholder || 'Select an icon...'}
          iconName={value || undefined}
          size='lg'
          inputProps={{ readOnly: true, style: { cursor: 'pointer' } }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleOpen()
            }
          }}
        />
      </div>

      <IconPickerDialog
        open={open}
        onClose={handleClose}
        value={value}
        onConfirm={handleConfirm}
      />
    </>
  )
}

IconPickerField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

export default IconPickerField
